// 组件注册的入口文件
import BeeIcon from './components/icon'
import BeeInput from './components/input'
import BeeAutocomplete from './components/autocomplete'
import BeeSelect from './components/select'
import BeeSwitch from './components/switch'
import BeeTable from './components/table'
import BeePage from './components/page'

const components = [
  BeeIcon,
  BeeInput,
  BeeAutocomplete,
  BeeSelect,
  BeeSwitch,
  BeeTable,
  BeePage
]

const install = (Vue, opts = {}) => {
  if(install.installed) return
  components.map(component => {
    Vue.component(component.name, component)
  })
}

// 支持使用标签的方式引入
if(typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  BeeIcon,
  BeeInput,
  BeeAutocomplete,
  BeeSelect,
  BeeSwitch,
  BeeTable,
  BeePage
}



// WEBPACK FOOTER //
// ./src/index.js